module.exports = __webpack_public_path__ + "static/img/bnb_logo.a6869c73.png";